// npm
import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import { Box, BoxProps } from '@mui/material'

// src
import AccreditationCard from '../../cards/AccreditationCard'

export interface Props extends BoxProps {}

const Accreditations = ({ ...props }: Props) => {
  const data = useStaticQuery<Queries.AccreditationsQuery>(graphql`
    query Accreditations {
      allDatoCmsAccreditation(sort: { fields: position, order: ASC }) {
        edges {
          node {
            ...accreditation
          }
        }
      }
    }
  `)

  const accreditations = data.allDatoCmsAccreditation.edges
  let chunks = new Array()
  const chunkSize = 2
  for (let i = 0; i < accreditations.length; i += chunkSize) {
    chunks.push(accreditations.slice(i, i + chunkSize))
  }
  console.log('chunks', chunks)

  const sizes = { xs: 110, md: 130, xl: 160 }

  return (
    <Box
      display={{ xs: 'block', md: 'flex' }}
      alignItems="center"
      mt={{ xs: 4, md: 6, lg: 8, xl: 10 }}
      {...props}
    >
      {chunks.map((chunk: any, index: number) => {
        return (
          <Box
            key={`chunk-${index}`}
            display="flex"
            alignItems="center"
            justifyContent="center"
          >
            {chunk.map((item: any) => {
              const accreditation: Queries.accreditationFragment = item.node

              return (
                <AccreditationCard
                  key={accreditation.originalId}
                  data={accreditation}
                  mx={3}
                  width="100%"
                  height={sizes}
                  flex={1}
                />
              )
            })}
          </Box>
        )
      })}
    </Box>
  )
}

export default Accreditations
